import { render } from "./RetailMainTable.vue?vue&type=template&id=d961d8c8"
import script from "./RetailMainTable.vue?vue&type=script&lang=js"
export * from "./RetailMainTable.vue?vue&type=script&lang=js"

import "@/styles/table.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__